import Busqueda from '../components/Busqueda';

export default function AnaliticasVentas() {
  return (
    <div className="flex flex-col h-screen bg-black overflow-hidden">
      <header
        className="flex items-center justify-between px-6"
        style={{
          height: '112px',
          borderBottom: '1px solid #343434',
        }}
      >
        <div>
          <h1
            className="text-white font-semibold uppercase m-0"
            style={{ fontSize: '24px', fontFamily: '"Public Sans", sans-serif' }}
          >
            Analíticas de ventas
          </h1>
          <p
            className="m-0 mt-1"
            style={{ fontSize: '14px', fontWeight: 500, color: '#8D8D8D', fontFamily: '"Public Sans", sans-serif' }}
          >
            dashboard de métricas y rendimiento
          </p>
        </div>
        <Busqueda />
      </header>
      <div className="flex-1 min-h-0 overflow-y-auto p-6 pl-8 pr-8">
        <div
          style={{
            flex: 1,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            minHeight: '500px',
          }}
        />
      </div>
    </div>
  );
}
